
import React, { useState, useEffect } from 'react';
import { Marker } from 'react-map-gl';


interface LoadMarkerProps {
    snapshots: Array<Record<string, unknown>> | boolean
}

interface PointObject {
    id: number
    lng: number,
    lat: number,
}

export default function LoadMarkers(props: LoadMarkerProps) {

    const [snapsList, setSnaplist] = useState<Array<PointObject>>([]);
    const [poisList, setPoiList] = useState<Array<PointObject>>([]);
    const [myProp, setMyProp] = useState<PointObject>();


    useEffect(() => {

        const snaps = [] as Array<PointObject>;
        const pois = [] as Array<PointObject>;
        let prop = {} as PointObject;

        if (props.snapshots !== false) {
            props.snapshots.forEach((el: Record<string, Record<string, unknown> | string | unknown>, index: number) => {
                const items = {
                    id: 0,
                    lat: 0,
                    lng: 0
                };
                items.id = index;
                if (el["type"] === "POI") {
                    if (el["centroid"]) {
                        items.lat = el["centroid"]["lat"];
                        items.lng = el["centroid"]["lng"];
                        pois.push(items);
                    }

                }
                else if (el["type"] === "SNAPSHOT") {
                    if (el["centroid"]) {
                        items.lat = el["centroid"]["lat"];
                        items.lng = el["centroid"]["lng"];
                        snaps.push(items);
                    }

                }
                else if (el["type"] === "MY_PROPERTY") {
                    if (el["centroid"]) {
                        items.lat = el["centroid"]["lat"];
                        items.lng = el["centroid"]["lng"];
                        prop = items;
                    }
                }
            })
        }
        setMyProp(prop);
        setPoiList(pois);
        setSnaplist(snaps);
    }, [props.snapshots])

    return (<>
        { myProp && Object.keys(myProp).length !== 0 ?
            <Marker longitude={myProp.lng} latitude={myProp.lat} anchor="center" >
                <img src="./images/Pins/blue_marker.png" alt="" />
            </Marker>
            : <></>
        }


        {poisList.length > 0 ? poisList.map(POI => {
            return (
                <Marker longitude={POI.lng} latitude={POI.lat} anchor="center" key={POI.id} >
                    <img src="./images/Pins/green_marker.png" alt="" />
                </Marker>
            );
        }): <></>}
        {snapsList.length > 0 ? snapsList.map(SNAP => {
            return (
                <Marker longitude={SNAP.lng} latitude={SNAP.lat} anchor="center" key={SNAP.id} >
                    <img src="./images/Pins/yellow_marker.png" alt="" />
                </Marker>
            );
        }) : <></>}

    </>);

}